import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { AccountDetails, HelpDetails } from 'components'
import { Icon as MTCIcon } from 'images/inspira-logo.svg'
import { Icon as HelpIcon } from 'images/help-outline-thick.svg'
import { NavLink, Link } from 'react-router-dom'
import { selectors as globalSelectors } from '../main/reducer'
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  isSearchServicesEnabled,
  isBenefitDistributionsEnabled,
  isNotificationsEnabled,
  Path,
  isTaxableCustodialAccountsEnabled,
} from 'config/portal'

const propTypes = {
  isAdmin: PropTypes.bool.isRequired,
}

const defaultProps = {}
function Header({ isAdmin }) {
  return (
    <header className="header">
      <div id="header-action-area">
        <Link className="mtc-logo" to="/home" aria-label="Home">
          <MTCIcon className="header-mtc-logo" />
        </Link>
        <div className="header-action-area-left">
          <ul>
            <li>
              <NavLink to="/home">Home</NavLink>
            </li>
            <li>
              <NavLink to={Path.SERVICES_AGREEMENTS}>
                Automatic rollovers
              </NavLink>
            </li>
            {isSearchServicesEnabled() && (
              <li>
                <NavLink to={Path.SEARCH_HISTORY}>Search services</NavLink>
              </li>
            )}
            {isBenefitDistributionsEnabled() && (
              <li>
                <NavLink to={Path.BD_SERVICES_AGREEMENTS}>
                  Benefit distributions
                </NavLink>
              </li>
            )}
            {isNotificationsEnabled() && (
              <li>
                <NavLink to={Path.NOTIFICATIONS_HISTORY}>
                  Notification services
                </NavLink>
              </li>
            )}
            {isTaxableCustodialAccountsEnabled() && (
              <li>
                <NavLink to={Path.TAXABLE_ACCOUNTS_SERVICES_AGREEMENTS}>
                  Taxable accounts
                </NavLink>
              </li>
            )}
            <li>
              <NavLink to="/faq">FAQ</NavLink>
            </li>
          </ul>
        </div>
        <div className="header-right">
          <div className="header-action-area-right">
            <HelpDetails helpIcon={<HelpIcon />} />
            <AccountDetails isAdmin={isAdmin} />
          </div>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = exact(propTypes)
Header.defaultProps = defaultProps

Header.displayName = 'Header'

function mapStateToProps(state) {
  return {
    isAdmin: globalSelectors.isAdmin(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Header)
